module.exports = __webpack_public_path__ + "img/電気回路_6_2_2.e5c35e5f.png";